import type { AutocompleteResponse, AutocompleteOption } from '../../../../types';

import { ppAutocompleteMapper } from '../../common/autocomplete/AutocompleteMapper';

export const usePrePackageAutocompleteMapper = (lookupCount: (id: string) => number) => {
    return (response: AutocompleteResponse): AutocompleteOption[] =>
        ppAutocompleteMapper(response)
            .map((suggestion) => ({ ...suggestion, count: lookupCount(suggestion.id) }))
            .sort((a, b) => (a.count && b.count ? b.count - a.count : 0))
            .slice(0, 8);
};
